import { CultureMediaList } from "./CultureMediaList";
import { CultureMediaShow } from "./CultureMediaShow";
import { CultureMediaCreate } from "./CultureMediaCreate";
import { CultureMediaEdit } from "./CultureMediaEdit";

export const culture_media = {
  list: CultureMediaList,
  show: CultureMediaShow,
  create: CultureMediaCreate,
  edit: CultureMediaEdit,
};
